import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setAddedDevices, setRemovedDevices } from '#action/project/devices-popup';
import { getSymmetricDifference, getDeviceDiff } from '#component/device/devices-popup/helper';

export const useFloatDevicesSyncShipment = (
  formDataObj,
  openedFromForm,
  addMode,
  renderRef,
  emptyForm,
  refetchDataRef
) => {
  const { projectId } = formDataObj;

  const dispatch = useDispatch();
  // formDataObj values are supplied by the RHF-based cargo form
  const formInitialValues = formDataObj?.initialFormDevices;
  const formDevices = useMemo(
    () => formDataObj?.formDevices ?? [],
    [formDataObj?.formDevices]
  );

  useEffect(() => {
    if (!openedFromForm || !projectId || emptyForm) {
      refetchDataRef.current = true;
      return;
    }

    if (!formInitialValues || !formDevices.length) {
      return;
    }

    const symmetricDiff = getSymmetricDifference(formDevices, formInitialValues);
    const isDevicesWasReplaced = formDevices?.length === formInitialValues?.length &&
      symmetricDiff.length;

    if (isDevicesWasReplaced && !addMode) {
      const devicesDiff = getDeviceDiff(formDevices, formInitialValues);
      const diffWithSymmetric = getDeviceDiff(symmetricDiff, devicesDiff);

      if (devicesDiff.length) {
        dispatch(setAddedDevices(devicesDiff));
      }

      if (diffWithSymmetric.length) {
        dispatch(setRemovedDevices(diffWithSymmetric));
      }
    } else {
      const addedDevices = getDeviceDiff(formDevices, formInitialValues);
      const removedDevices = getDeviceDiff(formInitialValues, formDevices);

      if (addedDevices.length) {
        dispatch(setAddedDevices(addedDevices));
      }

      if (removedDevices.length) {
        dispatch(setRemovedDevices(removedDevices));
      }
    }

    refetchDataRef.current = true;
  }, [
    addMode,
    dispatch,
    projectId,
    formDevices,
    openedFromForm,
    formInitialValues,
    renderRef,
    emptyForm,
    refetchDataRef
  ]);
};
